import { observer } from "mobx-react";
import React from "react";
import Form from "./Form";
import HideFields from "../../Views/Table/HideFields";
import Filter from "./Filter";
import Group from "./group/Group";
import Sort from "./Sort";
import Color from "./Color";
import RowHeight from "./RowHeight";
import RowDirection from "./RowDirection";
import Options from "./Options";
import { CircularProgress, Button } from "@material-ui/core";
import RefreshData from "./RefreshData";
import { useContext } from "react";
import { ViewStoreContext } from "../ContainerStore";
import styled from "styled-components";

function TableButtons(props) {
  const viewStore = useContext(ViewStoreContext);
  if (!viewStore) {
    return null;
  }

  return (
    <div
      className="textCenter d-flex"
      style={{ marginLeft: 1, alignItems: "center" }}
    >
      <Form />
      <HideFields viewStore={viewStore} />
      <Filter />
      <Group
        updateGrid={viewStore.redrawGridForGrouping}
        store={viewStore}
        gridApi={viewStore.gridApi}
        themeColor={props.themeColor}
      />
      <Sort store={viewStore} gridApi={viewStore.gridApi} />
      <Color />
      <RowHeight
        rowHeight={props.rowHeight}
        setRowHeight={viewStore.setRowHeight}
      />
      <Options store={viewStore} gridApi={viewStore.gridApi} />
      <RefreshData store={viewStore} params={props.params} />
      {(viewStore.containerStore?.permissions?.isAdmin() || props.store?.listConfig?.list?.is_log_sheet == "1") && (
          <RowDirection store={viewStore} />
      )}
      {(process.env.NODE_ENV === "development" ||
        viewStore.loadTypeButtonShown) && (
        <Button
          // variant="contained"
          disabled={viewStore.isGridGrouped}
          onClick={() => {
            viewStore.isLazyLoadEnabled = !viewStore.isLazyLoadEnabled;
            viewStore.addGrid();
          }}
        >
          {viewStore.isLazyLoadEnabled ? "Load All Rows" : "Lazy Load"}
        </Button>
      )}
      {(viewStore.currentApiCallsCount > 0 || viewStore.isTabNameChanging) && (
        <div style={{ color: "green" }}>
          <CircularProgress size={10} color={"inherit"} /> Saving...
        </div>
      )}
       {(viewStore.isCommentsColumnSaving) && (
        <div style={{ color: "green" }}>
          <CircularProgress size={10} color={"inherit"} /> Saving...
        </div>
      )}
      {Object.keys(viewStore.executingEvents).length > 0 && (
        <div style={{ color: "green" }}>
          <CircularProgress size={10} color={"inherit"} /> Executing...
        </div>
      )}
      {viewStore.isColumnDeleting && (
        <div style={{ color: "red" }}>
          <CircularProgress size={10} color={"inherit"} /> deleting column...
        </div>
      )}
      {viewStore.isSheetDeleting && (
        <DeleteSheetDiv>
          <CircularProgress size={10} color={"inherit"} /> deleting sheet...
        </DeleteSheetDiv>
      )}
      {viewStore.isExportingLazyLoadData && (
        <ExportSheetDiv>
          <CircularProgress size={10} color={"inherit"} /> exporting data...
        </ExportSheetDiv>
      )}
      {viewStore.isViewSaving && (
        <ExportSheetDiv>
          <CircularProgress size={10} color={"inherit"} /> saving view...
        </ExportSheetDiv>
      )}
    </div>
  );
}

const DeleteSheetDiv = styled.div`
  color: red;
`;

const ExportSheetDiv = styled.div`
  color: green;
`;

export default observer(TableButtons);
